import { shouldBlockOrganizationRoute } from '~/utils/userAccountType'
import { isImpersonationCallbackPath } from '~/utils/impersonationRoute'

export default async function({ store, redirect, route, from }) {
	/**
	 * User does not have a auth token
	 * -> Redirect to login page
	 */
	if (!store.getters['user/loggedIn']) {
		return redirect(200, '/auth/login', {
			redirect: route.fullPath != '/' ? route.fullPath : null
		})
	}

	/**
	 * User has a auth token but no user data
	 * -> Fetch user data
	 */
	const needsUser = !store.getters['user/user']
	if (needsUser) {
		await store.dispatch('user/getUser')
	}

	/**
	 * Get fresh user data on first page load or when navigating from auth pages
	 */
	const fromImpersonation = isImpersonationCallbackPath(from.path)

	if (
		!needsUser &&
		(route.fullPath === from.fullPath ||
			(from.path?.startsWith('/auth/') && !fromImpersonation))
	) {
		await store.dispatch('user/getUser')

		// Clear applicant profile cache when coming from auth pages to prevent cross-user contamination
		if (from.path?.startsWith('/auth/') && !fromImpersonation) {
			store.commit('applicantProfile/setApplicantProfile', null)
		}
	}
	if (shouldBlockOrganizationRoute(store.getters['user/user'], route.path)) {
		return redirect(200, '/organization-unavailable')
	}
}
